import { isFilterActive } from '../molecules/activeFilter.styles';
import { AGE_TYPES } from '../molecules/AgeSelector';
import { EDUCATIONAL_LEVEL_TYPES } from '../molecules/EducationalLevelSelector';
import { LEGAL_STATUS_TYPES } from '../molecules/LegalStatusSelector';
import { ETHNICITY_TYPES } from '../../containers/Beneficiaries/constants';

const RADIO_LABEL_KEYS = {
  sex: { male: 'common.male', female: 'common.female' },
  active: { true: 'beneficiaries.active', false: 'beneficiaries.inActive' }
};

const enumResolver = (types, translationPrefix) => (value, { intlMessages }) =>
  types.includes(value) ? intlMessages[`${translationPrefix}${value}`] : null;

const radioResolver = field => (value, { intlMessages }) => {
  const key = (RADIO_LABEL_KEYS[field] || {})[`${value}`];

  return key ? intlMessages[key] : null;
};

const byIdResolver = collectionName => (value, context) => {
  const match = (context[collectionName] || []).find(item => `${item.id}` === `${value}`);

  return (match || {}).name || null;
};

const ageRangeLabel = (range, { intlMessages }) => {
  const match = AGE_TYPES.find(type => type.value.min === range.min && type.value.max === range.max && !range.custom);

  if (range.custom) return `${range.min} - ${range.max} ${intlMessages['common.years']}`;

  return match ? `${match.label} ${intlMessages['common.years']}` : null;
};

const ageChips = (values, context, removeAgeRange) =>
  (values.age || []).map((range, index) => ({
    key: `age-${index}`,
    label: ageRangeLabel(range, context),
    onRemove: () => removeAgeRange(range)
  }));

const SINGLE_VALUE_FIELDS = [
  { name: 'ethnicity', resolve: enumResolver(ETHNICITY_TYPES, 'beneficiaries.form.') },
  { name: 'sex', resolve: radioResolver('sex') },
  { name: 'active', resolve: radioResolver('active') },
  { name: 'legal_status', resolve: enumResolver(LEGAL_STATUS_TYPES, 'beneficiaries.') },
  { name: 'industry_id', resolve: byIdResolver('industries') },
  { name: 'project_id', resolve: byIdResolver('projects') },
  { name: 'educational_level', resolve: enumResolver(EDUCATIONAL_LEVEL_TYPES, 'selector.educationLevel.') },
  { name: 'profession_id', resolve: byIdResolver('professions') },
  { name: 'country_id', resolve: byIdResolver('countries') },
  { name: 'query', resolve: value => value }
];

export const buildBeneficiariesFilterChips = ({ values = {}, defaults = {}, context, removeField, removeAgeRange }) => {
  const singleChips = SINGLE_VALUE_FIELDS.filter(({ name }) => isFilterActive(values[name], defaults[name])).map(({ name, resolve }) => ({
    key: name,
    label: resolve(values[name], context),
    onRemove: () => removeField(name)
  }));

  return [...ageChips(values, context, removeAgeRange), ...singleChips].filter(chip => !!chip.label);
};
